import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_C9PG_URL || "https://testlink.c9pg.com:11911";
const API_URL = process.env.REACT_APP_API_URL || '/';

// ACH config - Store Accounting 999's config for ACH payments
const DEFAULT_ACH_CONFIG = {
    // DGMX
    //GMID: "1110103171",
    //GTID: "GT1120045728",
    //GMPW: "GMPW3010022626"

    // PROD
    GMID: "1511005240",
    GTID: "GT1520028620",
    GMPW: "12345678"

};

const getApiEndpoints = (config) => ({
    SALE: `${API_BASE_URL}/Payment/Sale#Sale?TerminalType=None&NeedSwipeCard=N&GMID=${config.GMID}`,
    TOKENIZATION: `${API_BASE_URL}/Payment/Sale#Tokenization?TerminalType=None&NeedSwipeCard=N&GMID=${config.GMID}`,
    ADJUST: `${API_BASE_URL}/Payment/Auth#Modify_Adjust_AddTip?TerminalType=None&NeedSwipeCard=N&GMID=${config.GMID}`,
    REVERSE: `${API_BASE_URL}/Payment/Auth#Void_Reverse_Cancel?TerminalType=None&NeedSwipeCard=N&GMID=${config.GMID}`,
    SWIPE: `${API_BASE_URL}/Payment/Sale?TerminalType=Pax&NeedSwipeCard=Y&GMID=${config.GMID}&ServiceType=Card`,
    ACH: `${API_BASE_URL}/Payment/Auth#ACHDebit?TerminalType=None&NeedSwipeCard=N&GMID=${config.GMID}`,
});

// Credit Card
export const makePayment = async (paymentRequest, cardMachineConfig, invoiceNum = null) => {
    try {
        // CardMachine config provided?
        if (!cardMachineConfig || !cardMachineConfig.GMID || !cardMachineConfig.GTID || !cardMachineConfig.GMPW) {
            throw new Error('CardMachine configuration not provided. Cannot process credit card payment.');
        }

        const terminalConfig = cardMachineConfig;

        console.log('Payment Request', paymentRequest);

        const request = {
            ...terminalConfig,
            ...paymentRequest,
            TransType: "Sale",
            ...(invoiceNum && { InvoiceNum: invoiceNum })
        };

        const endpoints = getApiEndpoints(terminalConfig);
        const response = await axios.post(endpoints.SALE, request);
        return response.data;
    } catch (error) {
        console.error('Payment failed:', error);
        throw error;
    }
};

// BIN lookup to determine card type (credit vs debit)
export const getCardInfo = async (accountNum, cardMachineConfig, expDate = null) => {
    try {
        if (!cardMachineConfig?.GMID || !cardMachineConfig?.GMPW) {
            throw new Error('CardMachine configuration not provided. Cannot perform card lookup.');
        }
        const endpoint = `${API_BASE_URL}/api/query/GetCardInfo?GMID=${cardMachineConfig.GMID}`;
        const request = {
            GMID: cardMachineConfig.GMID,
            GMPW: cardMachineConfig.GMPW,
            TransType: "GetCardInfo",
            AccountNum: accountNum,
            ...(expDate ? { ExpDate: expDate } : {})
        };
        const response = await axios.post(endpoint, request);
        console.log('GetCardInfo response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Card info lookup failed:', error);
        throw error;
    }
};

// Card token
export const getCardToken = async (tokenRequest, cardMachineConfig, medium = "Credit") => {
    try {
        // CardMachine config provided?
        if (!cardMachineConfig || !cardMachineConfig.GMID || !cardMachineConfig.GTID || !cardMachineConfig.GMPW) {
            throw new Error('CardMachine configuration not provided. Cannot create card token.');
        }

        const terminalConfig = cardMachineConfig;

        const request = {
            ...terminalConfig,
            ...tokenRequest,
            TransType: "CreateCardToken",
            Medium: medium,
            EntryMode: "Manual",
            RequestCardToken: "Y",
            // VerifyCard: "N",
            IgnoreAVSResult: (window.appConfig?.IgnoreAVSResult ?? true) ? "Y" : "N",
            IgnoreCVVResult: (window.appConfig?.IgnoreCVVResult ?? true) ? "Y" : "N"
        };

        console.log('Token Request', request);
        const endpoints = getApiEndpoints(terminalConfig);
        console.log('endpoints', endpoints);
        const response = await axios.post(endpoints.TOKENIZATION, request);
        console.log('Token response:', response.data);

        if (response.data.ErrorCode !== '000' && response.data.ErrorCode !== '100' && response.ErrorText !== 'APPROVAL') {
            console.error('Token error:', response.data.ErrorText);
            return {
                success: false,
                message: response.data.ErrorText || 'Token creation error',
                ...response.data
            };
        }

        return response.data;
    }
    catch (error) {
        console.error('Token creation failed:', error);
        return {
            success: false,
            message: error.message || 'Token creation failed',
            error: error
        };
    }
}

// Card Token Payment
export const makePaymentByToken = async (tokenData, cardMachineConfig, medium = "Credit") => {
    try {
        // CardMachine config?
        if (!cardMachineConfig || !cardMachineConfig.GMID || !cardMachineConfig.GTID || !cardMachineConfig.GMPW) {
            throw new Error('CardMachine configuration not provided. Cannot process token payment.');
        }

        const terminalConfig = cardMachineConfig;

        const amountInCents = Math.round(parseFloat(tokenData.amount) * 100);
        console.log('[makePaymentByToken] tokenData.amount:', tokenData.amount, 'amountInCents:', amountInCents);

        const tokenRequest = {
            ...terminalConfig,
            TransType: "Sale",
            Medium: medium,
            EntryMode: "Manual",
            MainAmt: amountInCents,
            CardToken: tokenData.token || '',
            CardholderName: tokenData.cardholderName || '',
            InvoiceNum: tokenData.invoiceNumber || '',
            ...(tokenData.cvv && { CVVNum: tokenData.cvv }), // TEMP COMMENTED OUT
            ...(tokenData.zipCode && { CustomerZipCode: tokenData.zipCode }), // TEMP COMMENTED OUT
            // VerifyCard: "Y",
            IgnoreAVSResult: (window.appConfig?.IgnoreAVSResult ?? true) ? "Y" : "N",
            IgnoreCVVResult: (window.appConfig?.IgnoreCVVResult ?? true) ? "Y" : "N"
        };
        const endpoints = getApiEndpoints(terminalConfig);
        const response = await axios.post(endpoints.SALE, tokenRequest);

        if (response.data.ErrorCode !== '000' && response.data.ErrorCode !== '100' && response.data.ErrorText !== 'APPROVAL' && response.data.ErrorText !== "No Error") {
            console.error('Payment error:', response.data.ErrorText);
            return {
                success: false,
                message: response.data.ErrorText || 'Payment processing error',
                transactionId: response.data.GTRC || '',
                ...response.data
            };
        }

        // Success
        return {
            success: true,
            message: 'Payment processed successfully',
            transactionId: response.data.GTRC || '',
            ...response.data
        };
    } catch (error) {
        console.error('Token payment failed:', error);
        return {
            success: false,
            message: error.message || 'Payment processing error',
            error: error
        };
    }
}

// Manual Card Sale with token returned in a single call
export const makeManualCardSale = async (cardDetails, cardMachineConfig, medium = "Credit") => {
    try {
        if (!cardMachineConfig?.GMID || !cardMachineConfig?.GTID || !cardMachineConfig?.GMPW) {
            throw new Error('CardMachine configuration not provided. Cannot process card payment.');
        }
        const request = {
            ...cardMachineConfig,
            ...cardDetails,
            TransType: "Sale",
            Medium: medium,
            EntryMode: "Manual",
            RequestCardToken: "Y",
            IgnoreAVSResult: (window.appConfig?.IgnoreAVSResult ?? true) ? "Y" : "N",
            IgnoreCVVResult: (window.appConfig?.IgnoreCVVResult ?? true) ? "Y" : "N"
        };
        console.log('Manual card sale request:', request);
        const endpoints = getApiEndpoints(cardMachineConfig);
        const response = await axios.post(endpoints.TOKENIZATION, request);
        console.log('Manual card sale response:', response.data);
        if (response.data.ErrorCode !== '000' && response.data.ErrorCode !== '100' &&
            response.data.ErrorText !== 'APPROVAL' && response.data.ErrorText !== 'No Error') {
            return { success: false, message: response.data.ErrorText || 'Payment error', ...response.data };
        }
        return {
            success: true,
            message: 'Payment processed successfully',
            transactionId: response.data.GTRC || '',
            ...response.data
        };
    } catch (error) {
        console.error('Manual card sale failed:', error);
        return { success: false, message: error.message || 'Payment processing error', error };
    }
};

// ACH Token
export const getAchToken = async (achInfo, achConfig = null) => {
    try {
        // Use provided ACH config if available, otherwise fall back to DEFAULT_ACH_CONFIG
        const terminalConfig = DEFAULT_ACH_CONFIG; // achConfig || DEFAULT_ACH_CONFIG;

        const tokenRequest = {
            ...terminalConfig,
            TransType: "CreateCardToken",
            Medium: "ElectronicCheck",
            EntryModel: "Manual",
            EleCheckRoutingNumber: achInfo.routingNumber || achInfo.EleCheckRoutingNumber,
            EleCheckAccountNumber: achInfo.accountNumber || achInfo.EleCheckAccountNumber,
            AccountType: achInfo.accountType || achInfo.AccountType
        };

        const endpoints = getApiEndpoints(terminalConfig);
        const response = await axios.post(endpoints.ACH, tokenRequest);
        return response.data;
    } catch (error) {
        console.error('E-Check token creation failed:', error);
        throw error;
    }
}

// ACH Payment
export const makeAchPayment = async (achInfo, achConfig = null, invoiceNum = null) => {
    try {
        console.log('makeAchPayment:', achInfo);
        // Use provided ACH config if available, otherwise fall back to DEFAULT_ACH_CONFIG
        const terminalConfig = DEFAULT_ACH_CONFIG; //achConfig || DEFAULT_ACH_CONFIG;

        const request = {
            ...achInfo,
            ...terminalConfig,
            Medium: "ElectronicCheck",
            TransType: "Sale",
            EntryMode: "Manual",
            EleCheckServiceProvider: "ElecCheckWEB",
            EleCheckTransactionType: "EleCheckConversion",
            GMID: terminalConfig.GMID,
            GTID: terminalConfig.GTID,
            GMPW: terminalConfig.GMPW,
            ...(invoiceNum && { InvoiceNum: invoiceNum })
        };

        console.log('E-Check request:', request);
        const endpoints = getApiEndpoints(terminalConfig);
        const response = await axios.post(endpoints.ACH, request);
        console.log('E-Check response:', response.data);
        
        if (response.data.ErrorCode !== '000' && response.data.ErrorCode !== '100' && response.data.ErrorText !== 'APPROVAL' && response.data.ErrorText !== "No Error") {
            console.error('E-Check payment error:', response.data.ErrorText);
            return {
                success: false,
                message: response.data.ErrorText || 'ACH payment processing error',
                transactionId: response.data.GTRC || '',
                ...response.data
            };
        }
        
        // Success
        return {
            success: true,
            message: 'ACH payment processed successfully',
            transactionId: response.data.GTRC || '',
            ...response.data
        };
    } catch (error) {
        console.error('ACH payment failed:', error);
        return {
            success: false,
            message: error.message || 'ACH payment processing error',
            error: error
        };
    }
}

export const postPaymentToDatabase = async (paymentInfo) => {
    try {
        const response = await axios.post(`${API_URL}/payments/CreatePayment`, paymentInfo);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        console.error('Error posting payment:', error);
        return {
            success: false,
            message: error.response?.data?.message || error.message || 'Error creating payment'
        };
    }
}

export const postTransactionToDatabase = async (transactionInfo, cardMachineConfig = null) => {
    try {
        const isAchTransaction = transactionInfo.Medium === 'ElectronicCheck' ||
                                 transactionInfo.paymentType === 'ACH' ||
                                 transactionInfo.paymentType === 'E-Check';

        let machineConfig;
        if (cardMachineConfig) {
            machineConfig = cardMachineConfig;
        } else if (isAchTransaction) {
            // Fall back to DEFAULT_ACH_CONFIG only if no config provided
            machineConfig = DEFAULT_ACH_CONFIG;
        } else {
            console.error('No CardMachine configuration available for transaction');
            //machineConfig = { GMID: null, GTID: null, GMPW: null };
            machineConfig = DEFAULT_ACH_CONFIG;
        }

        const transactionWithCardMachine = {
            ...transactionInfo,
            GMID: machineConfig.GMID,
            GTID: machineConfig.GTID,
            GMPW: machineConfig.GMPW
        };

        const response = await axios.post(`${API_URL}/payments/SaveTransaction`, transactionWithCardMachine);
        console.log('Transaction save response:', response.data);
        return {
            success: true,
            data: response.data.data || response.data
        };
    } catch (error) {
        console.error('Error saving transaction:', error);
        return {
            success: false,
            message: error.response?.data?.message || error.message || 'Error saving transaction'
        };
    }
}

export const updatePaymentLinkStatus = async (paymentLinkId, status) => {
    try {
        const response = await axios.put(`${API_URL}/paymentlinks/${paymentLinkId}/status`, { status });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        console.error('Error updating payment link status:', error);
        return {
            success: false,
            message: error.response?.data?.message || error.message || 'Error updating payment link status'
        };
    }
}
